import ICommand from './ICommand';
import Element from '../element';

export default class RemoveElementCommand implements ICommand {

    constructor(
        private elements: Element[],
        private elementsToDelete: Element[],
    ) { }

    public execute(): void {
        const selectedElements = this.elementsToDelete;
        selectedElements.forEach((x) => x.isVisible = false);

        const filteredElements = this.elements.filter((x) => !selectedElements.includes(x));
        this.elements.splice(0, this.elements.length);
        this.elements.push(...filteredElements);
    }

    public revert(): void {
        this.elements.push(...this.elementsToDelete);
        this.elementsToDelete.forEach((x) => x.isVisible = true);
    }
}